var _rect, _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDraft(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.1,
    width: 40,
    height: 40,
    rx: 8,
    fill: "#0869FB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.7406 11.0609C13.9896 11.2442 13.4024 11.7297 13.0623 12.4485L12.8224 12.9559L12.8223 19.9403C12.8222 26.7144 12.8272 26.9384 12.9908 27.3755C13.2021 27.9402 13.7313 28.49 14.3422 28.7798L14.8066 29H19.9998H25.193L25.665 28.7787C26.2704 28.4948 26.7951 27.9468 27.0091 27.3749C27.1703 26.9437 27.1774 26.7132 27.1774 21.8749V16.825L26.9251 16.326C26.7263 15.9329 26.202 15.3491 24.4552 13.5759C22.523 11.6145 22.1832 11.3053 21.8153 11.1733C21.4418 11.0392 21.0277 11.0195 18.2265 11.0024C16.4849 10.9917 14.9162 11.018 14.7406 11.0609ZM20.5234 18.5752C20.7458 18.7976 20.7738 18.8748 20.7306 19.1452C20.638 19.7232 20.534 19.7535 18.6441 19.7535C17.0215 19.7535 16.9623 19.7475 16.7451 19.5607C16.573 19.4127 16.5208 19.2904 16.5208 19.0358C16.5208 18.7812 16.573 18.6588 16.7451 18.5109C16.9621 18.3242 17.0226 18.318 18.6177 18.318H20.2661L20.5234 18.5752ZM23.2868 22.2379C23.5651 22.5341 23.55 23.022 23.2546 23.2761L23.0303 23.469H20.0065C17.122 23.469 16.9729 23.4613 16.7704 23.3021C16.4169 23.024 16.4161 22.4068 16.7687 22.139C16.8741 22.0591 17.6569 22.0335 20.0012 22.0335H23.0947L23.2868 22.2379Z",
    fill: "url(#paint0_linear_1133_56236)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1133_56236",
    x1: 20.0012,
    y1: 10.3079,
    x2: 20.0012,
    y2: 29.6841,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2BB3F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3F64FA"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDraft);
export default __webpack_public_path__ + "static/media/Draft.0544ccf28f308902e6092ca4d61281b8.svg";
export { ForwardRef as ReactComponent };